export default __webpack_public_path__ + "static/media/earthLogo.70e38ab5.svg";